import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { usePump } from "@/context/PumpContext";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const { pump, setPump } = usePump();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("bep_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => { setUser(r.data); if (r.data?.pump) setPump(r.data.pump); })
      .catch(() => localStorage.removeItem("bep_token"))
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);

  const login = async (employee_id, password) => {
    const { data } = await api.post("/auth/login", { employee_id, password, cc: pump?.cc || null });
    localStorage.setItem("bep_token", data.token);
    setUser(data.user);
    if (data.user?.pump) setPump(data.user.pump);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("bep_token");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
